import { render, staticRenderFns } from "./StaticMenu.vue?vue&type=template&id=88740be4&scoped=true&"
import script from "./StaticMenu.vue?vue&type=script&lang=js&"
export * from "./StaticMenu.vue?vue&type=script&lang=js&"
import style0 from "./StaticMenu.vue?vue&type=style&index=0&id=88740be4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88740be4",
  null
  
)

export default component.exports